import dayjs from 'dayjs';

export const discountsMixin = {
    data() {
        return {
            loading: false,
            discountTypes: [],
            detail_image_preview: null,
            cruises: [],
            ships: [],
            cruises_info: [],
            ships_info: [],
            maxLengthShortDescription: 106,
            formData: {
                name: null,
                short_title: '',
                slug: null,
                discount_amount: null,
                hot: false,
                type: null,
                from: null,
                to: null,
                active: false,
                show_on_main_page: false,
                main_banner: null,
                // main_banner_delete: false,
                main_banner_mobile: null,
                // main_banner_mobile_delete: false,
                // preview_image_square: null,
                // preview_image_square_delete: false,
                // preview_image_hr_rectangle: null,
                // preview_image_hr_rectangle_delete: false,
                // preview_image_vr_rectangle: null,
                // preview_image_vr_rectangle_delete: false,
                // detail_image: null,
                // detail_image_delete: false,
                description: null,
                short_description: '',
                content_order: null,
                cruise_ids: null,
                ship_ids: null,
                search_title: null,
            },
            custom_fields: this.getDefaultCustomFields(),
            seoHeaders: [
                { field: 'code', label: 'Название параметра' },
                { field: 'value', label: 'Значение' },
            ],
        };
    },
    methods: {
        // clearForm() {
        //     for (const key in this.form) {
        //         this.form[key] = null;
        //     }
        // },
        getDefaultCustomFields() {
            return [
                { code: 'title', value: '' },
                { code: 'keywords', value: '' },
                { code: 'description', value: '' },
            ];
        },
        mapFormData() {
            return {
                ...this.formData,
                from: this.formData.from ? new Date(this.formData.from) : null,
                to: this.formData.to ? new Date(this.formData.to) : null,
                custom_fields: this.custom_fields,
            };
        },
        async fetchCreateParams() {
            this.loading = true;

            try {
                const { data } = await this.axios.get(`/discounts/create`);

                this.discountTypes = data.data.discount_types;

                this.loading = false;
            } catch (ex) {
                this.loading = false;
                this.$router.push('/error-page');
            }
        },
        async fetchEditParams() {
            this.loading = true;

            try {
                const { data } = await this.axios.get(`/discounts/${this.$route.params.id}/edit`);

                // this.cruises = data.data.cruises_info;
                // this.ships = data.data.ships_info;

                // заполняем данные
                for (const [key, val] of Object.entries(data.data)) {
                    if (key === 'cruises_info') {
                        this.cruises_info = val;
                        console.log('cruises_info', this.cruises_info);
                    }

                    if (key === 'ships_info') {
                        this.ships_info = val;
                    }

                    this.formData[key] = val;
                }

                this.formData.cruise_ids = this.cruises_info.map((c) => c.id);
                this.formData.ship_ids = this.ships_info.map((s) => s.id);

                const response = { ...data.data };

                this.formData.from = response.from ? dayjs(response.from).format('YYYY-MM-DDTHH:mm:ss') : null;
                this.formData.to = response.to ? dayjs(response.to).format('YYYY-MM-DDTHH:mm:ss') : null;

                this.custom_fields = response.custom_fields.length
                    ? response.custom_fields
                    : this.getDefaultCustomFields();
            } catch (ex) {
                console.log('cannot fetch discount edit params ' + ex);
                this.$router.push('/error-page');
            } finally {
                this.loading = false;
            }
        },

        async fetchCruises(searchString) {
            try {
                const { data } = await this.axios.get('/cruises', {
                    params: {
                        searchString,
                    },
                });

                const selectedCruises =
                    this.cruises_info?.filter((c) => this.formData.cruise_ids?.includes(c.id)) || [];

                this.cruises = [
                    ...selectedCruises.map((c) => ({
                        id: c.id,
                        title: c.title,
                        ship_title: c.ship_title,
                        departure_date_time: c.departure_date_time,
                    })),
                    ...data.data.map((c) => ({
                        id: c.id,
                        title: c.title,
                        ship_title: c.ship_title,
                        departure_date_time: c.departure_date_time,
                    })),
                ].filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            } catch (ex) {
                console.log('cant fetch cruises: ' + ex);
            }
        },

        async fetchShips(searchString) {
            try {
                const { data } = await this.axios.get('/ships', {
                    params: {
                        searchString,
                    },
                });
                // this.ships = data.data.map((ship) => {
                //     return {
                //         id: ship.id,
                //         title: ship.title,
                //     };
                // });

                // Объединяем с уже выбранными теплоходами
                const selectedShips = this.ships_info?.filter((s) => this.formData.ship_ids?.includes(s.id)) || [];

                console.log(' fetchShips ~ selectedShips:', selectedShips);

                this.ships = [
                    ...selectedShips.map((s) => ({ id: s.id, title: s.title })),
                    ...data.data.map((s) => ({ id: s.id, title: s.title })),
                ].filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            } catch (ex) {
                console.log('cant fetch ships: ' + ex);
            }
        },

        onChangeCruises(label) {
            console.log(label);
        },
        stripHtml(html) {
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
    },
};
